import { useSelector } from 'react-redux';
import moment from 'moment';
import apis from '@src/apis';
import { EXPIRED_PACKAGE_MAX_PROJECTS } from '@src/constants/project';

/**
 * How many projects the current package still allows.
 *
 * An expired package falls back to a small fixed allowance instead of the one
 * the package used to grant. A limit of 0 means unlimited, so the count is only
 * fetched when there is an actual ceiling to compare against.
 *
 * Returns `{ limit, reached }` — `limit` is the allowance that applies, so the
 * caller can put the number in the "limit reached" message.
 */
const useProjectLimit = () => {
  const { user } = useSelector((state) => state.auth);

  const checkProjectLimit = async () => {
    const isExpiredPackage =
      Boolean(user?.packageExpiryDate) &&
      moment().isAfter(user.packageExpiryDate);
    const limit = isExpiredPackage
      ? EXPIRED_PACKAGE_MAX_PROJECTS
      : user?.studioUsageOptions?.maxProjects;

    if (!limit || limit <= 0) return { limit: 0, reached: false };

    const res = await apis.project.getProjectsCount();
    const count = res?.result?.count || 0;
    return { limit, reached: count >= limit };
  };

  return { checkProjectLimit };
};

export default useProjectLimit;
